import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/machinery/")({
  component: () => null,
  beforeLoad: () => {
    throw redirect({
      to: "/machinery/inspection",
      replace: true,
    });
  },
});
